import { StorageFileResponse, StorageFileResponseSchema } from "./storage-file-response"

export type StorageFileViewModel = StorageFileResponse & {
  extension: string
  isImage: boolean
}

export const makeStorageFileViewModel = (response: StorageFileResponse): StorageFileViewModel => {
  try {
    const parsed = StorageFileResponseSchema.parse(response)

    return {
      ...parsed,
      extension: getExtension(parsed.filename),
      isImage: parsed.contentType.startsWith("image/"),
    }
  } catch (error) {
    throw new Error(`Failed to parse storage file: ${error}`)
  }
}

const getExtension = (filename: string) => {
  return filename.split(".").pop()?.toLowerCase() || ""
}
